/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListUsersQueryVariables = Types.Exact<{
  offset: Types.InputMaybe<Types.Scalars['Int']>;
  limit: Types.InputMaybe<Types.Scalars['Int']>;
  name: Types.InputMaybe<Types.Scalars['String']>;
  filters: Types.InputMaybe<Types.UsersFilters>;
}>;


export type ListUsersQuery = { __typename: 'Query', listUsers: { __typename: 'UserResponse', total: string | null, users: Array<{ __typename: 'User', country_code: string, email: string, first_name: string, id: string, last_name: string, region_id: string | null, unit_id: string | null, label_id: string | null, space_id: string | null, role: { __typename: 'UserRole', role_id: string, expire_at: string | null } }> | null } };


export const ListUsersDocument = gql`
    query listUsers($offset: Int, $limit: Int, $name: String, $filters: UsersFilters) {
  listUsers(offset: $offset, limit: $limit, name: $name, filters: $filters) {
    users {
      country_code
      email
      first_name
      id
      last_name
      region_id
      unit_id
      label_id
      space_id
      role {
        role_id
        expire_at
      }
    }
    total
  }
}
    `;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      name: // value for 'name'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;